import { FC, useCallback, useEffect, useState } from 'react';
import { useAppDispatch } from 'hooks';
import { useSelector } from 'react-redux';
import { Layout, LayoutProps } from 'containers';
import { generatePath, useHistory, useParams } from 'react-router-dom';
import { Notification, userRole } from 'constant';
import { routes } from 'navigations/routers';
import { Col, Row } from 'antd';
import { userData } from '../Login/selectors';
import HistoryReceiving from '../Home/Dtc/NotificationHistory/HistoryReceiving';
import HistorySending from '../Home/Dtc/NotificationHistory/HistorySending';
import BoHistorySending from '../Home/Bo/BoHistory/BoHistorySending';
import BoHistoryReceiving from '../Home/Bo/BoHistory/BoHitoryReceiving';
import { notificationsSelector } from './selectors';
import { getHistoryReceiving, getHistorySending } from './thunk';

const Notifications: FC = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const { entity = Notification.RECEIVING } = useParams<{ entity: Notification }>();
  const { received, sent } = useSelector(notificationsSelector);
  const { roleUser } = useSelector(userData);
  const [current, setCurrent] = useState(1);
  const [currentSent, setCurrentSent] = useState(1);

  const fetchAPI = useCallback(() => {
    switch (entity) {
      case Notification.RECEIVING:
        return dispatch(getHistoryReceiving({ status: 0, per_page: 12, page: current - 1 }));
      case Notification.SENDING:
        return dispatch(getHistorySending({ status: 1, per_page: 12, page: currentSent - 1 }));
    }
  }, [current, currentSent, dispatch, entity]);

  useEffect(() => {
    (async () => {
      await fetchAPI();
    })();
  }, [fetchAPI]);

  const handleSelectedTab = useCallback(
    (entity) => {
      return history.replace(generatePath(routes.Notifications.path, { entity }));
    },
    [history]
  );
  return (
    <Row>
      <Col>
        <Layout
          tabs={tabs}
          onSelected={handleSelectedTab}
          right={false}
          defaultValue={entity}
          left
          back
        />
        {entity === Notification.RECEIVING && roleUser === userRole.DTC && (
          <HistoryReceiving data={received} loading={received.loading} setCurrent={setCurrent} />
        )}
        {entity === Notification.SENDING && roleUser === userRole.DTC && (
          <HistorySending data={sent} loading={sent.loading} setCurrentSent={setCurrentSent} />
        )}
        {entity === Notification.SENDING && roleUser === userRole.BO && (
          <BoHistorySending data={sent} loading={sent.loading} setCurrentSent={setCurrentSent} />
        )}
        {entity === Notification.RECEIVING && roleUser === userRole.BO && (
          <BoHistoryReceiving data={received} loading={received.loading} setCurrent={setCurrent} />
        )}
      </Col>
    </Row>
  );
};

const tabs: LayoutProps['tabs'] = [
  { label: '受信履歴', key: Notification.RECEIVING },
  { label: '送信履歴', key: Notification.SENDING },
];

export default Notifications;
